<template>
  <FocusTrap v-if="inputMode">
    <LexmeaInput
      v-model="localTitle"
      type="text"
      maxlength="300"
      @blur="saveTitle"
      @keyup.enter="saveTitle"
    />
  </FocusTrap>
  <component
    :is="isMainContent ? 'h1' : 'h2'"
    v-else
    class="truncate-after-3-lines group font-semibold"
    :class="{ 'text-lg': largeTitle, 'text-8pt': !largeTitle }"
    :title="title"
    @click="inputMode = entry.editable"
  >
    {{ title }}
    <i-heroicons-pencil-solid
      v-if="entry.editable"
      class="inline-block cursor-pointer text-gray-500 opacity-0 transition-opacity hover:text-black group-hover:opacity-100"
    />
  </component>
</template>

<script lang="ts" setup>
import type { ISchema } from "~/models/IUserEntry";

const props = defineProps<{
  title?: string;
  entry: ISchema;
  isMainContent: boolean;
  largeTitle?: boolean;
}>();

const emit = defineEmits<{
  save: [text: string];
  toggle: [value: boolean];
}>();

const localTitle = ref(props.title);
const inputMode = ref(false);

watchEffect(() => {
  localTitle.value = props.title;
});

watchEffect(() => {
  emit("toggle", inputMode.value);
});

const saveTitle = () => {
  inputMode.value = false;
  if (localTitle.value === props.title) {
    return;
  }
  if (localTitle.value) {
    emit("save", localTitle.value);
  }
};
</script>
<style scoped>
.truncate-after-3-lines {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
